export const splitFilterValues = (value) => {
  if (Array.isArray(value)) return value.filter(Boolean);
  if (value === undefined || value === null || value === "") return [];

  return String(value)
    .split(",")
    .map((item) => item.trim())
    .filter((item) => item && item !== "all");
};

const embeddedLabel = (value) => {
  const label = String(value).split("~")[1];
  if (!label) return "";
  return label === "other" ? "Lainnya" : label;
};

export const summarizeFilterValues = (value, options = []) => {
  const values = splitFilterValues(value);
  if (!values.length) return "";

  const labelsByValue = new Map(
    options.map((option) => [String(option.value), option.label])
  );
  const firstLabel = values
    .map((item) => labelsByValue.get(String(item)) || embeddedLabel(item))
    .find(Boolean);

  if (!firstLabel) return `${values.length} dipilih`;
  return values.length > 1 ? `${firstLabel} +${values.length - 1}` : firstLabel;
};

export const optionLabel = (value, options = [], fallback = "Dipilih") =>
  options.find((option) => String(option.value) === String(value))?.label || fallback;

export const quotedSearchLabel = (value) => `Pencarian: “${value}”`;
